import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let contactEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/contact/Edit');
let faqIndex = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Index');
let faqCreate = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Create');
let faqCategories = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Categories');
let ceoIndex = () => import(/* webpackChunkName: "ceo" */ '@/views/pages/ceo/Index');
let ceoEdit = () => import(/* webpackChunkName: "ceo" */ '@/views/pages/ceo/Edit');
let tenderTerms = () => import(/* webpackChunkName: "tender" */ '@/views/pages/tender/Terms');
let page = () => import(/* webpackChunkName: "plans" */ '@/views/pages/page/Index');
let pageCreate = () => import(/* webpackChunkName: "plans" */ '@/views/pages/page/Create');
let pageEdit = () => import(/* webpackChunkName: "plans" */ '@/views/pages/page/Edit');
let seoIndex = () => import(/* webpackChunkName: "plans" */ '@/views/pages/seo/Index');
let membersPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/members/Edit');
let communitiesPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/communities/Edit');
let servicesPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/services/Edit');
let newsPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/news/Edit');
let projectsPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/projects/Edit');
let blogPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/blog/Edit');
let faqPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/faq/EditHeader');
let teamPageEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/team/Edit');

export default [
    ...prefix("/pages",[
        {
            path: "contacts",
            name: "contacts.edit",
            component: contactEdit,
            meta: {
                middleware: web,
                permissions: ['settings:contactUsPage'],
                title: "تماس با ما"
            }
        },
        {
            path: "faqs",
            name: "faqs.index",
            component: faqIndex,
            meta: {
                middleware: web,
                permissions: ['faqs:viewAny'],
                title: "سوالات متداول"
            }
        },
        {
            path: "faqs/create",
            name: "faqs.create",
            component: faqCreate,
            meta: {
                middleware: web,
                permissions: ['faqs:create'],
                title: "ایجاد سوال متداول"
            }
        },
        {
            path: "faqs/categories",
            name: "faqs.categories.index",
            component: faqCategories,
            meta: {
                middleware: web,
                permissions: ['faq-categories:viewAny'],
                title: "دسته بندی سوالات متداول"
            }
        },
        {
            path: "ceo",
            name: "ceo.index",
            component: ceoIndex,
            meta: {
                middleware: web,
                permissions: ['ceo-contacts:viewAny'],
                title: "درخواست ارتباط با ریاست"
            }
        },
        {
            path: "ceo/:id",
            name: "ceo.edit",
            component: ceoEdit,
            meta: {
                middleware: web,
                permissions: ['ceo-contacts:update','ceo-contacts:view'],
                title: "نمایش درخواست"
            }
        },
        {
            path: "tender",
            name: "tender.terms",
            component: tenderTerms,
            meta: {
                middleware: web,
                permissions: ['settings:tenderTerms'],
                title: "شرایط مناقصه"
            }
        },
        {
            path: "dynamic-pages",
            name: "dynamic-pages.index",
            component: page,
            meta: {
                middleware: web,
                permissions: ['pages:viewAny'],
                title: "صفحات پویا"
            }
        },
        {
            path: "dynamic-pages/create",
            name: "dynamic-pages.create",
            component: pageCreate,
            meta: {
                middleware: web,
                permissions: ['pages:create'],
                title: " ایحاد صفحه"
            }
        },
        {
            path: "dynamic-pages/:id",
            name: "dynamic-pages.edit",
            component: pageEdit,
            meta: {
                middleware: web,
                permissions: ['pages:update','pages:view'],
                title: "  ویرایش صفحه"
            }
        },
        {
            path: "seo",
            name: "seo.index",
            component: seoIndex,
            meta: {
                middleware: web,
                permissions: ['settings:seo'],
                title: "سئوی صفحات"
            }
        },
        {
            path: "members/page",
            name: "members.page",
            component: membersPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:membersPage'],
                title: "ویرایش صفحه اعضا"
            }
        },
        {
            path: "communities/page",
            name: "communities.page",
            component: communitiesPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:communitiesPage'],
                title: "ویرایش صفحه جوامع"
            }
        },
        {
            path: "services/page",
            name: "services.page",
            component: servicesPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:servicesPage'],
                title: "ویرایش صفحه سرویس‌ها"
            }
        },
        {
            path: "projects/page",
            name: "projects.page",
            component: projectsPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:projectsPage'],
                title: "ویرایش صفحه پروژه‌ها"
            }
        },
        {
            path: "news/page",
            name: "news.page",
            component: newsPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:newsPage'],
                title: "ویرایش صفحه اخبار"
            }
        },
        {
            path: "blog/page",
            name: "blog.page",
            component: blogPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:blogPage'],
                title: "ویرایش صفحه بلاگ"
            }
        },
        {
            path: "faqs/page",
            name: "faqs.page",
            component: faqPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:faqPage'],
                title: "ویرایش صفحه سوالات متداول"
            }
        },
        {
            path: "team/page",
            name: "team.page",
            component: teamPageEdit,
            meta: {
                middleware: web,
                permissions: ['settings:teamPage'],
                title: "ویرایش صفحه اعضای تیم"
            }
        },
        ])
    ]
